// extracted by mini-css-extract-plugin
export default {"inputField":"OneSide_inputField__t2tkP","form":"OneSide_form__UGhmJ"};